import { gql } from '@/__generated__/gql';

export const EDIT_INVESTOR_PAGE_ENTITY_GROUPING_CREATE_GROUP_MUTATION = gql(`
  mutation EditInvestorPageEntityGroupingCreateGroup($data: CreateGroupInput!) {
    createGroup(data: $data) {
      id
    }
  }
`);

export const EDIT_INVESTOR_PAGE_ENTITY_GROUPING_UPDATE_GROUP_MUTATION = gql(`
  mutation EditInvestorPageEntityGroupingUpdateGroup($data: UpdateGroupInput!) {
    updateGroup(data: $data) {
      id
    }
  }
`);

export const EDIT_INVESTOR_PAGE_ENTITY_GROUPING_REMOVE_GROUP_MUTATION = gql(`
  mutation EditInvestorPageEntityGroupingRemoveGroup($id: String!) {
    deleteGroup(id: $id)
  }
`);
